import type { ValueTypeResource } from '@/features/legends/api/resources/engine'
import {
  mapUnknownResourceToElement,
  UnknownElementError,
  type ValueType,
} from './legend-document'

/**
 * Maps an engine value type.
 *
 * @param resource
 */
export function mapValueTypeResourceToValueType(
  resource: ValueTypeResource,
): ValueType {
  switch (resource.type) {
    case 'Number':
    case 'String':
    case 'Boolean':
    case 'Date':
      return { type: resource.type }
    case 'List':
      return {
        type: 'List',
        itemType: mapValueTypeResourceToValueType(resource.itemType),
      }
  }
  return mapUnknownResourceToElement(resource)
}

/**
 * Maps a value type to the engine's.
 *
 * @param valueType
 */
export function mapValueTypeToResource(
  valueType: ValueType,
): ValueTypeResource {
  switch (valueType.type) {
    case 'Number':
    case 'String':
    case 'Boolean':
    case 'Date':
      return { type: valueType.type }
    case 'List':
      return {
        type: 'List',
        itemType: mapValueTypeToResource(valueType.itemType),
      }
    case 'Unknown':
      throw new UnknownElementError('value', valueType)
  }
}
